import { setWithExpiry } from '../../Domain/Helpers/LocalStorageHelper';
import { postApiCall } from '../Handlers/HttpHandler';

/**
 * Calls the login endpoint, stores token + roles in localStorage on success.
 */
export const loginCall = async (email, password) => {
  const result = await postApiCall('auth/login', {
    email,
    password,
  });

  if (result.data !== null && result.data?.token) {
    const duration = (process.env.REACT_APP_TOKEN_DURATION || 8) * 3600 * 1000;
    setWithExpiry('token', result.data.token, duration);
    setWithExpiry('roles', result.data.roles, duration);
  }

  return result;
};

/**
 * Calls the logout endpoint and removes token + roles from localStorage.
 */
export const logoutCall = async (token) => {
  try {
    await postApiCall('auth/logout', {}, token);
  } finally {
    localStorage.removeItem('token');
    localStorage.removeItem('roles');
  }
  return true;
};
